import _defineProperty from "/workdir/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/workdir/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/workdir/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { ConfiguredFlowError, ConfigError } from '../../util/Errors.js';
import { emailVerifyCallback } from './emailVerifyCallback.js';
import sessionStorageHelper from './sessionStorageHelper.js';
import { CONFIGURED_FLOW } from './constants.js';
/*!
 * Copyright (c) 2021, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

var handleProxyIdxResponse = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(settings) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", Promise.resolve({
              rawIdxState: settings.get('proxyIdxResponse'),
              context: settings.get('proxyIdxResponse'),
              neededToProceed: []
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function handleProxyIdxResponse(_x) {
    return _ref.apply(this, arguments);
  };
}();
/* eslint max-depth: [2, 3] */
// eslint-disable-next-line complexity, max-statements


function startLoginFlow(_x2) {
  return _startLoginFlow.apply(this, arguments);
}

function _startLoginFlow() {
  _startLoginFlow = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(settings) {
    var authClient, _settings$toJSON, authParams, nonce, idxOptions, meta, flow, stateHandleFromSession, _idxResp$context, _idxResp$context$mess, idxResp, hasError, stateHandle;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            authClient = settings.getAuthClient(); // nonce is not a top-level auth-js option, must be passed in manually

            _settings$toJSON = settings.toJSON({
              verbose: true
            }), authParams = _settings$toJSON.authParams;
            nonce = settings.get('nonce') || (authParams === null || authParams === void 0 ? void 0 : authParams.nonce);
            idxOptions = _objectSpread({
              exchangeCodeForTokens: false
            }, nonce && {
              nonce: nonce
            }); // Return a preset response

            if (!settings.get('proxyIdxResponse')) {
              _context2.next = 6;
              break;
            }

            return _context2.abrupt("return", handleProxyIdxResponse(settings));

          case 6:
            if (settings.get('overrideExistingStateToken')) {
              sessionStorageHelper.removeStateHandle();
            }

            if (!settings.get('otp')) {
              _context2.next = 9;
              break;
            }

            return _context2.abrupt("return", emailVerifyCallback(settings));

          case 9:
            if (!settings.get('oauth2Enabled')) {
              _context2.next = 19;
              break;
            }

            _context2.next = 12;
            return authClient.idx.getSavedTransactionMeta();

          case 12:
            meta = _context2.sent;

            if (meta) {
              _context2.next = 18;
              break;
            }

            // no saved transaction
            // if the configured flow is set to `proceed`, the SIW should only continue an existing idx transaction
            // if the SIW loads from a fresh state (there is no current transaction), throw an error
            flow = authClient.idx.getFlow();

            if (!(flow && flow === CONFIGURED_FLOW.PROCEED)) {
              _context2.next = 17;
              break;
            }

            throw new ConfiguredFlowError('Unable to proceed: saved transaction could not be loaded', flow);

          case 17:
            return _context2.abrupt("return", authClient.idx.start(idxOptions));

          case 18:
            return _context2.abrupt("return", authClient.idx.proceed(idxOptions));

          case 19:
            // Use stateToken from session storage if exists
            // See more details at ./docs/use-session-token-prior-to-settings.png
            stateHandleFromSession = sessionStorageHelper.getStateHandle();

            if (!stateHandleFromSession) {
              _context2.next = 36;
              break;
            }

            _context2.prev = 21;
            _context2.next = 24;
            return authClient.idx.start(_objectSpread(_objectSpread({}, idxOptions), {}, {
              stateHandle: stateHandleFromSession
            }));

          case 24:
            idxResp = _context2.sent;
            hasError = ((_idxResp$context = idxResp.context) === null || _idxResp$context === void 0 ? void 0 : (_idxResp$context$mess = _idxResp$context.messages) === null || _idxResp$context$mess === void 0 ? void 0 : _idxResp$context$mess.value.length) > 0;

            if (!hasError) {
              _context2.next = 28;
              break;
            }

            throw new Error('saved stateToken is invalid');

          case 28:
            // 1. abandon the settings.stateHandle given session.stateHandle is still valid
            settings.set('stateToken', stateHandleFromSession); // 2. chain the idxResp to next handler

            return _context2.abrupt("return", idxResp);

          case 32:
            _context2.prev = 32;
            _context2.t0 = _context2["catch"](21);
            // 1. remove session.stateHandle
            sessionStorageHelper.removeStateHandle(); // 2. start the login again in order to introspect on settings.stateHandle

            return _context2.abrupt("return", startLoginFlow(settings));

          case 36:
            // Use stateToken from options
            stateHandle = settings.get('stateToken');

            if (!stateHandle) {
              _context2.next = 39;
              break;
            }

            return _context2.abrupt("return", authClient.idx.start(_objectSpread(_objectSpread({}, idxOptions), {}, {
              stateHandle: stateHandle
            })));

          case 39:
            throw new ConfigError('Invalid OIDC configuration. Set "clientId" and "redirectUri" in the widget options.');

          case 40:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[21, 32]]);
  }));
  return _startLoginFlow.apply(this, arguments);
}

export { startLoginFlow };